import { countDown } from '../game/server-restart.js';
import { element } from './kit.js';
import { uiFormat, uiText } from './text.js';
import './restart-banner.css';

/**
 * The countdown of a deploy (`server_restart`): a plate at the top of the
 * screen, above every window, so a player in the middle of a dialogue still
 * sees it coming. The canvas status would sit under the DOM panels.
 */
export class RestartBanner {
  private readonly root = element('div', 'restart-banner');
  private readonly count = element('span', 'restart-banner__count');
  private stop: (() => void) | undefined;

  constructor() {
    this.root.setAttribute('role', 'status');
    this.root.setAttribute('aria-live', 'polite');
    this.root.append(element('span', 'restart-banner__kicker', uiText('Mise à jour')), this.count);
    document.body.append(this.root);
  }

  start(seconds: number): void {
    this.stop?.();
    this.stop = countDown(seconds, (left) => {
      this.count.textContent = uiFormat('Redémarrage du serveur dans {seconds} s', {
        seconds: left,
      });
    });
  }

  destroy(): void {
    this.stop?.();
    this.root.remove();
  }
}
